import { IsBoolean } from 'class-validator';

export class ValidateUniqueManagerPinResponseDto {
  /**
   * Flag indicating unique Manager Pin in cost center
   */
  @IsBoolean() public isUnique: boolean;

  constructor(isUnique: boolean) {
    this.isUnique = isUnique;
  }
}
